import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ColdWorkPermitSignatureType } from '../shared/enum/shared.enum';
import { Subscription } from 'rxjs';
import { ContractorHotWorkPermitService } from '../service/contractor-hot-work-permit.service';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { AddSignatureModal } from '../workpermit/add-signature-modal/add-signature-modal.component';
import { finalize } from 'rxjs/operators';
import { TimeFormatPipe } from '../shared/pipe/time-format.pipe';
@Component({
  selector: 'app-contractor-cold-work-permit',
  templateUrl: './contractor-cold-work-permit.component.html',
  styleUrls: ['./contractor-cold-work-permit.component.scss'],
})
export class ContractorColdWorkPermitComponent implements OnInit {
  isToggleMenu: boolean = false;
  isFormSubmited = false;
  customSegment: number = 1;
  disableSegment1: boolean = false;
  disableSegment2: boolean = false;
  disableSegment3: boolean = false;
  siteOfWorkContainsOther: boolean = false;
  activitiesContainsOther: boolean = false;
  cwpId: number;
  systemCurrentDate = new Date();
  workDetailsFormGroup: FormGroup;
  roundsAndObservationsFormGroup: FormGroup;
  contractorReportFormGroup: FormGroup;
  loadingRef: HTMLIonLoadingElement;
  coldWorkPermitSignatureType = ColdWorkPermitSignatureType;
  signitureSubscription: Subscription;
  signatureUploadSubscription: Subscription;
  workDetailsData = [];
  constructor(private datePipe: DatePipe, private router: Router, private activatedRoutes: ActivatedRoute,
    private fb: FormBuilder, private contractorService: ContractorHotWorkPermitService,
    private loadingController: LoadingController, private alertController: AlertController,
    private modalController: ModalController, private timeFormat: TimeFormatPipe) { }

  ngOnInit() {
    this.disableSegment1 = true;
    this.cwpId = this.activatedRoutes?.snapshot?.queryParams?.id;
    this.workDetailsFormGroup = this.fb.group({
      cwpDetails: this.contractorService.getCWPFormDetails(),
      listOfInspection: this.contractorService.getInspectionList(),
      contractorApprovalSign: this.contractorService.getHotWorkPermitSignature(),
      optDeptApprovalSign: this.contractorService.getHotWorkPermitSignatureNotMandetory(),
      exeDepApprovalSign: this.contractorService.getHotWorkPermitSignatureNotMandetory(),
      safetyDepApprovalSign: this.contractorService.getHotWorkPermitSignatureNotMandetory(),
      cwpExtention: this.fb.array([this.contractorService.getHWPExtention()])
    });
    this.roundsAndObservationsFormGroup = this.fb.group({
      roundsObservation: this.fb.array([this.contractorService.getRoundsObservationDetails()]),
      contractorClosureSign: this.contractorService.getHotWorkPermitSignatureNotMandetory(),
      cwpOptDeptClosureSignaure: this.contractorService.getHotWorkPermitSignatureNotMandetory(),
      cwpExeDepClosureSignature: this.contractorService.getHotWorkPermitSignatureNotMandetory(),
      cwpViolation: this.fb.array([this.contractorService.getHotWorkPermitViolation()]),
      cwpViolationSign: this.contractorService.getHotWorkPermitViolationSignature()
    });
    this.contractorReportFormGroup = this.fb.group({
      report: this.fb.array([this.contractorService.getReport()])
    })
    this.setHWPExtentionArray();
    this.getCWPDetailsById();
    this.hideLoaderIfExist();
  }
  get cwpDetailsFormGroup(){
    return (this.workDetailsFormGroup.get('cwpDetails'));
  }
  get ListOfInspectionFormGroup(){
    return (this.workDetailsFormGroup.get('listOfInspection'));
  }
  get contractorApprovalSignFormGroup(){
    return (this.workDetailsFormGroup.get('contractorApprovalSign'));
  }
  get optDeptApprovalSigFormGroup(){
    return (this.workDetailsFormGroup.get('optDeptApprovalSign'));
  }
  get exeDepApprovalSignFormGroup(){
    return (this.workDetailsFormGroup.get('exeDepApprovalSign'));
  }
  get safetyDepApprovalSignFormGroup(){
    return (this.workDetailsFormGroup.get('safetyDepApprovalSign'));
  }
  get cwpExtentionFormGroup(){
    return (this.workDetailsFormGroup.get('cwpExtention'));
  }
  get roundsDetialsFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('roundsObservation');
  }
  get violationFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('cwpViolation');
  }
  get violationSignFormGroup(){
    return this.roundsAndObservationsFormGroup.get('cwpViolationSign');
  }
  get cwpContractorClosureSignatureFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('contractorClosureSign');
  }
  get cwpOptDeptClosureSignaureFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('cwpOptDeptClosureSignaure');
  }
  get cwpExeDepClosureSignatureFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('cwpExeDepClosureSignature');
  }
  get reportFormGroup(){
    return this.contractorReportFormGroup.get('report')
  }
  setHWPExtentionArray(){
    for(let i = 0; i < 7; i++){
      if(i < 6){
        const reportControl = <FormArray>this.workDetailsFormGroup.controls['cwpExtention'];
        reportControl.push(this.contractorService.getHWPExtention());
      }
      const prepareData = {
        day: 'Day ' + (i+1)
      }
      const row = this.workDetailsFormGroup.get('cwpExtention') as FormArray;
      row.controls[i].patchValue({...prepareData});
    }
  }
  setReportFormArray(coldWorkPermit){
    var date1 = new Date(coldWorkPermit.fromDate);
    var date2 = new Date(coldWorkPermit.toDate);
    var reportDates = [];
    while(date1<=date2){
      reportDates.push(this.datePipe.transform(date1))
      date1.setDate(date1.getDate()+1);
    }
    for(let i = 0; i < reportDates.length; i++){
      if(i < reportDates.length-1){
        const reportControl = <FormArray>this.contractorReportFormGroup.controls['report'];
        reportControl.push(this.contractorService.getReport());
      }
      const prepareData = {
        date: new Date(reportDates[i]),
        day: 'Day ' + (i+1)
      }
      const row = this.contractorReportFormGroup.get('report') as FormArray;
      row.controls[i].patchValue({...prepareData});
    }
    console.log("Report",this.contractorReportFormGroup.controls.report)
  }
  getCWPDetailsById(){
    this.contractorService.callGetApiByID('api/contractorColdWorkPermit/get-all-Data-by-coldworkpermit-id',this.cwpId).subscribe((data)=>{
      if(data.data){
        this.workDetailsData = data.data.coldWorkPermit
        this.setReportFormArray(data.data.coldWorkPermit)
        this.setWorkDetailsData(data.data.coldWorkPermit);
        this.setInspectionData(data.data.coldWorkPermitInspectionByFireTeam);
        this.setApprovalSignData(data.data.coldWorkPermit,data.data.listColdWorkPermitApproval);
        this.setCWPExtentionData(data.data.listColdWorkPermitExtension);
        this.setRoundsAndObservationData(data.data.listColdWorkPermitRoundAndObservation);
        this.setViolationData(data.data.listColdWorkPermitViolations);
        this.setViolationSignData(data.data.listColdWorkPermitViolationsSignature);
        this.setClosureSignData(data.data.listColdWorkPermitClosure);
        this.setReportData(data.data.coldWorkPermitContractorReporting);
      }
    },(error)=>{
      console.log("Error!!",error)
    },()=>{})
  }
  setWorkDetailsData(coldWorkPermit){
    if(coldWorkPermit){
      let activitiesArray = coldWorkPermit?.activitiesNeeded?.split(',');
      let siteOfWorkArray = coldWorkPermit?.siteOfWork?.split(',');
      this.siteOfWorkContainsOther = siteOfWorkArray.includes('Other');
      this.activitiesContainsOther = activitiesArray.includes('Other');
      this.workDetailsFormGroup.controls.cwpDetails.patchValue({
        ...coldWorkPermit,
        fromTime: this.timeFormat.transform(coldWorkPermit.fromTime),
        toTime: this.timeFormat.transform(coldWorkPermit.toTime),
        siteOfWork: [],
        activitiesNeeded: [],
      });
      this.workDetailsFormGroup.controls.cwpDetails.value.activitiesNeeded.forEach((item1)=>{
        if(activitiesArray.find(item2 => item2.toLowerCase() === item1.name.toLowerCase())){
          item1.checked = true;
        }else{
          item1.checked = false;
        }
      })
      this.workDetailsFormGroup.controls.cwpDetails.value.siteOfWork.forEach((item1)=>{
        if(siteOfWorkArray.find(item2 => item2.toLowerCase() === item1.name.toLowerCase())){
          item1.checked = true;
        }else{
          item1.checked = false;
        }
      })
    }
    console.log("cwpDetails",this.workDetailsFormGroup.controls.cwpDetails.value);
  }
  setInspectionData(coldWorkPermitInspectionByFireTeam){
    if(coldWorkPermitInspectionByFireTeam){
      let hoursArray = [];
      hoursArray = coldWorkPermitInspectionByFireTeam[0]?.hours?.split(',');
      // coldWorkPermitInspectionByFireTeam.forEach((item)=>{
      //   hoursArray.push(item.hours)
      // })
      this.workDetailsFormGroup.controls.listOfInspection.value.forEach((data,i) => {
        if(hoursArray?.find(item => item.toLowerCase() === data.name.toLocaleLowerCase())){
          data.checked = true
        }else{
          data.checked = false
        }
      });
    }
    console.log("listOfInspection",this.workDetailsFormGroup.controls.listOfInspection.value);
  }
  setApprovalSignData(coldWorkPermit,listColdWorkPermitApproval){
    if(coldWorkPermit['signature']){
      const prepareContractorApprovalSign = {
        signature: coldWorkPermit['signature'],
        name: coldWorkPermit['nameOfContractor'],
        userType: 'Contractor'
      }
      this.workDetailsFormGroup.controls.contractorApprovalSign.patchValue({
        ...prepareContractorApprovalSign
      });
    }
    if(listColdWorkPermitApproval.length > 0){
      listColdWorkPermitApproval.forEach((item) =>{
        const prepareData = {
          ...item,
          name: item?.responsiblePerson['firstName'] + `${' '}`+ item?.responsiblePerson['lastName']
        }
        if(item.userType == "Operating Department"){
          this.workDetailsFormGroup.controls.optDeptApprovalSign.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Fire Safety Department"){
          this.workDetailsFormGroup.controls.safetyDepApprovalSign.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Executing Department"){
          this.workDetailsFormGroup.controls.exeDepApprovalSign.patchValue({
            ...prepareData
          });
        }
      })
    }
    console.log("contractorApprovalSign",this.workDetailsFormGroup.controls.contractorApprovalSign.value);
    console.log("optDeptApprovalSign",this.workDetailsFormGroup.controls.optDeptApprovalSign.value);
    console.log("exeDepApprovalSign",this.workDetailsFormGroup.controls.exeDepApprovalSign.value);
    console.log("safetyDepApprovalSign",this.workDetailsFormGroup.controls.safetyDepApprovalSign.value);
  }
  setCWPExtentionData(listColdWorkPermitExtension){
    for(let i = 0; i < listColdWorkPermitExtension?.length; i++){
      const prepareData = {
        date: this.datePipe.transform(listColdWorkPermitExtension[i].date, "dd-MM-yyyy"),
        shiftOrTime: listColdWorkPermitExtension[i].shiftOrTime,
        signature: listColdWorkPermitExtension[i].signature,
        id:listColdWorkPermitExtension[i].id
      }
      const row = this.workDetailsFormGroup.get('cwpExtention') as FormArray;
      row.controls[i].patchValue({...prepareData});
    }
    console.log("cwpExtention",this.workDetailsFormGroup.controls.cwpExtention.value);
  }
  setRoundsAndObservationData(listColdWorkPermitRoundAndObservation){
    if(listColdWorkPermitRoundAndObservation?.length > 0){
      for(let i = 0; i < listColdWorkPermitRoundAndObservation?.length; i++){
        if(i < listColdWorkPermitRoundAndObservation.length-1){
          const control = <FormArray>this.roundsAndObservationsFormGroup.controls['roundsObservation'];
          control.push(this.contractorService.getRoundsObservationDetails())
        }
        const row = this.roundsAndObservationsFormGroup.get('roundsObservation') as FormArray
        row.controls[i].patchValue({...listColdWorkPermitRoundAndObservation[i]})
        if(listColdWorkPermitRoundAndObservation[i].signature){
          const prepareData = {
            signature: listColdWorkPermitRoundAndObservation[i].signature,
            fileName: listColdWorkPermitRoundAndObservation[i].fileName,
            name: listColdWorkPermitRoundAndObservation[i].user?.firstName + `${' '}`+ listColdWorkPermitRoundAndObservation[i].user?.lastName
          }
          this.roundsAndObservationsFormGroup.controls.cwpViolationSign.patchValue({
            fireSafetyDept: prepareData
          });
        }
      } 
    }else{
      const control = <FormArray>this.roundsAndObservationsFormGroup.controls['roundsObservation'];
      control.removeAt(0);
    }
    console.log("roundsObservation",this.roundsAndObservationsFormGroup.controls.roundsObservation.value);
  }
  setViolationData(listColdWorkPermitViolations){
    if(listColdWorkPermitViolations?.length > 0){
      for(let i = 0; i < listColdWorkPermitViolations.length; i++){
        if(i < listColdWorkPermitViolations.length-1){
          const control = <FormArray>this.roundsAndObservationsFormGroup.controls['cwpViolation'];
          control.push(this.contractorService.getHotWorkPermitViolation());
        }
        const row = this.roundsAndObservationsFormGroup.get('cwpViolation') as FormArray
        row.controls[i].patchValue({...listColdWorkPermitViolations[i]});
      }
    }else{
      const control = <FormArray>this.roundsAndObservationsFormGroup.controls['cwpViolation'];
      control.removeAt(0);
    }
    console.log("ViolationData",this.roundsAndObservationsFormGroup.controls.cwpViolation.value)
  }
  setViolationSignData(violationSign){
    console.log("Violationsign",violationSign)
    if(violationSign?.length > 0){
      violationSign.forEach((item) =>{
        const prepareData = {
          ...item,
          name: item.userId?.firstName + `${' '}`+ item.userId?.lastName
        }
        if(item.userType == "Operating Department"){
          this.roundsAndObservationsFormGroup.controls.cwpViolationSign.patchValue({
            optDept: prepareData
          });
        }else if(item.userType == "Executing Department"){
          this.roundsAndObservationsFormGroup.controls.cwpViolationSign.patchValue({
            exeDept: prepareData
          });
        }else if(item.userType == "Contractor"){
          this.roundsAndObservationsFormGroup.controls.cwpViolationSign.patchValue({
            contractor: prepareData
          });
        }/* else if(item.userType == "Fire Safety Department"){
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            fireSafetyDept: prepareData
          });
        } */
      })
    }
    console.log("cwpViolationSign",this.roundsAndObservationsFormGroup.controls.cwpViolationSign.value)
  }
  setClosureSignData(closureSign){
    if(closureSign?.length > 0){
      closureSign.forEach((item) =>{
        const prepareData = {
          ...item,
          id: item.id,
          name: item.respPerson?.firstName + `${' '}`+ item.respPerson?.lastName
        }
        if(item.userType == "Operating Department"){
          this.roundsAndObservationsFormGroup.controls.cwpOptDeptClosureSignaure.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Executing Department"){
          this.roundsAndObservationsFormGroup.controls.cwpExeDepClosureSignature.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Contractor"){
          this.roundsAndObservationsFormGroup.controls.contractorClosureSign.patchValue({
            ...prepareData
          });
        }
      })
    }
    console.log("contractorClosureSign",this.roundsAndObservationsFormGroup.controls.contractorClosureSign.value)
  }
  setReportData(coldWorkPermitContractorReporting){
    for(let i = 0; i < coldWorkPermitContractorReporting?.length; i++){
      if(coldWorkPermitContractorReporting[i].date == this.datePipe.transform(this.contractorReportFormGroup.controls.report.value[i].date,"dd-MM-yyyy")){
        const prepareData = {
          fileName: coldWorkPermitContractorReporting[i].fileName,
          signature: coldWorkPermitContractorReporting[i].signature,
          checkIn: coldWorkPermitContractorReporting[i].checkIn,
          chechInTime: this.timeFormat.transform(coldWorkPermitContractorReporting[i].chechInTime),
          chechOutTime: this.timeFormat.transform(coldWorkPermitContractorReporting[i].chechOutTime),
          id: coldWorkPermitContractorReporting[i].id
        }
        const row = this.contractorReportFormGroup.get('report') as FormArray;
        row.controls[i].patchValue({...prepareData});
      }
    }
    console.log("report",this.contractorReportFormGroup.controls.report.value)
  }
  clickToCheckInCheckOutDisabled(item): boolean {
    return this.cwpDetailsFormGroup.get('status').value != 'In-progress' || (this.datePipe.transform(this.systemCurrentDate,'yyyy-MM-dd') != this.datePipe.transform(item.value['date'],'yyyy-MM-dd'));
  }
  async clickToCheckIn(item){
    const alert =  await this.alertController.create({
      animated: true,
      backdropDismiss: false,
      cssClass: 'saveAsDraftAlert',
      header: 'ARE YOU SURE',
      message : 'Do you want to check in?',
      buttons: [
        { text: 'No', role: 'cancel', cssClass: 'cancel' },
        {
          text: 'Yes', role: 'Ok', cssClass: 'ok', handler: () => {
            item.value['chechInTime'] = this.datePipe.transform(new Date(), 'HH:mm a');
          }
        }
      ]
    });
    await alert.present();
  }
  async clickToCheckOut(item){
    const alert =  await this.alertController.create({
      animated: true,
      backdropDismiss: false,
      cssClass: 'saveAsDraftAlert',
      header: 'ARE YOU SURE',
      message : 'Do you want to check out?',
      buttons: [
        { text: 'No', role: 'cancel', cssClass: 'cancel' },
        {
          text: 'Yes', role: 'Ok', cssClass: 'ok', handler: () => {
            this.addReportSign(item);
          }
        }
      ]
    });
    await alert.present();
  }
  async addReportSign(item){
    if(this.signitureSubscription){
      this.signitureSubscription.unsubscribe();
    }
    const eventEmitterSubject = new EventEmitter;
    this.signitureSubscription = eventEmitterSubject.subscribe(res => {
      this.uploadReportSign(item,res);
    });
    const modal = await this.modalController.create({
      component: AddSignatureModal,
      componentProps: {
        isShowContractorInput:  false,
        onUpload: eventEmitterSubject
      },
      cssClass: 'addSign',
      animated: true,
      backdropDismiss: false
    });
    return await modal.present();
  }
  uploadReportSign(item,res){
    this.showLoader();
      this.contractorService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${res.fileName}&fileType=${res.fileType}`,res.formData)
        .pipe(finalize(() => {
          this.modalController.dismiss();
          this.loadingRef?.dismiss();
        }))
        .subscribe((data) => {
          if(data){
            console.log("Response!!",data,res.fileName);
            item.value['signature'] = data['data'][0]['filePath'];
            item.value['fileName'] = res.fileName;
            item.value['chechOutTime'] = this.datePipe.transform(new Date(), 'HH:mm a');
            item.value['checkIn'] = false;
            this.uploadSuccessMessage();
          }
        },
        (error) => {
          this.loadingRef?.dismiss();
          console.log("Something went wrong");
        }
      )
  }
  segmentChanged(event){
    setTimeout(() => {
      this.customSegment = event.detail.value;
      document.getElementById('ion-segment-' + event.detail.value)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    });
  }
  async addSignature(type){
    if(this.signitureSubscription){
      this.signitureSubscription.unsubscribe();
    }
    const eventEmitterSubject = new EventEmitter;
    this.signitureSubscription = eventEmitterSubject.subscribe(res => {
      if(type == ColdWorkPermitSignatureType.contractorApprovalSignature){
        this.uploadContractorApprovalsignature(res)
      }
      if(type == ColdWorkPermitSignatureType.contractorClosureSignature){
        this.uploadContractorClosuresignature(res)
      }
      if(type == ColdWorkPermitSignatureType.contractorViolationSignature){
        this.uploadContractorViolationsignature(res)
      }
    });
    const modal = await this.modalController.create({
      component: AddSignatureModal,
      componentProps: {
        isShowContractorInput:  false,
        isShowContractorInputReadOnly: true,
        NameOfContractor: this.workDetailsFormGroup.controls.cwpDetails.value.nameOfContractor,
        onUpload: eventEmitterSubject
      },
      cssClass: 'addSign',
      animated: true,
      backdropDismiss: false
    });
    return await modal.present();
  }
  uploadContractorApprovalsignature({formData, fileName, fileType}){
    this.showLoader();
    this.contractorService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${fileName}&fileType=${fileType}`,formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe((data) => {
        if(data){
          this.workDetailsFormGroup.controls.contractorApprovalSign.patchValue({
            signature: data['data'][0]['filePath'],
            fileName: fileName
          });
          console.log("Data!!",data)
          this.uploadSuccessMessage();
          console.log("contractorApprovalSign",this.workDetailsFormGroup.controls.contractorApprovalSign.value);
        }
      },
      (error) => {
        this.loadingRef?.dismiss();
        console.log("Something went wrong");
      }
    )
   
  }
  uploadContractorClosuresignature({formData, fileName, fileType}){
    this.showLoader();
    this.contractorService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${fileName}&fileType=${fileType}`,formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe((data) => {
        if(data){
          this.roundsAndObservationsFormGroup.controls.contractorClosureSign.patchValue({
            signature: data['data'][0]['filePath'],
            fileName: fileName,
            userType: "Contractor",
            date: this.datePipe.transform(new Date(),"dd-MM-yyyy")
          })
          this.uploadSuccessMessage();
        }
      },
      (error) => {
        this.loadingRef?.dismiss();
        console.log("Something went wrong");
      }
    )
  }
  uploadContractorViolationsignature({formData, fileName, fileType}){
    this.showLoader();
    this.contractorService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${fileName}&fileType=${fileType}`,formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe((data) => {
        if(data){
          const prepareData = {
            signature: data['data'][0]['filePath'],
            fileName: fileName,
            userType: "Contractor",
            date: this.datePipe.transform(new Date(),"dd-MM-yyyy")
          }
          this.roundsAndObservationsFormGroup.controls.cwpViolationSign.patchValue({
            contractor: prepareData
          })
          this.uploadSuccessMessage();
        }
      },
      (error) => {
        this.loadingRef?.dismiss();
        console.log("Something went wrong");
      }
    )
  }
  goToPrevious(){
    this.customSegment = --this.customSegment
  }
  cwpContractorSignFlag = false
  goToNext(){
    console.log(this.workDetailsFormGroup.controls.contractorApprovalSign)
    if(this.customSegment == 1){
      if(this.workDetailsFormGroup.valid){
        this.disableSegment2 = true;
        this.customSegment = ++this.customSegment;
      }else{
        this.cwpContractorSignFlag = true;
        this.workDetailsFormGroup.markAsDirty();
        this.workDetailsFormGroup.markAllAsTouched();
        this.errorAlert('Please fill all mandatory details');
      }
    }else if(this.customSegment == 2){
      if(this.roundsAndObservationsFormGroup.valid){
        this.disableSegment3 = true;
        this.customSegment = ++this.customSegment;
      }else{
        this.roundsAndObservationsFormGroup.markAsDirty();
        this.roundsAndObservationsFormGroup.markAllAsTouched();
        this.errorAlert('Please fill all mandatory details');
      }
    }
  }
  formSubmit(){
    if(this.workDetailsFormGroup.valid && this.contractorReportFormGroup.valid){
      let reportData = [];
      for(let i = 0; i < this.contractorReportFormGroup.controls.report.value.length; i++){
        if(this.contractorReportFormGroup.controls.report.value[i].chechInTime){
          const object = {
            chechInTime: this.contractorReportFormGroup.controls.report.value[i]['chechInTime'],
            chechOutTime: this.contractorReportFormGroup.controls.report.value[i]['chechOutTime'],
            checkIn: this.contractorReportFormGroup.controls.report.value[i]['checkIn'],
            date: this.datePipe.transform(this.contractorReportFormGroup.controls.report.value[i]['date'],"dd-MM-YYY"),
            day: this.contractorReportFormGroup.controls.report.value[i]['day'],
            fileName: this.contractorReportFormGroup.controls.report.value[i]['fileName'],
            id: this.contractorReportFormGroup.controls.report.value[i]['id'],
            signature: this.contractorReportFormGroup.controls.report.value[i]['signature']
          }
          reportData.push(object);
        }
      }
      const request = {
        "coldWorkPermitClosureSignRequest": this.roundsAndObservationsFormGroup.controls.contractorClosureSign.get('signature').value ? this.roundsAndObservationsFormGroup.controls.contractorClosureSign.value : null,
        "coldWorkPermitContractorReportingRequest": reportData,
        "coldWorkPermitVoilationsRequest": this.roundsAndObservationsFormGroup.controls.cwpViolationSign.get('contractor').value['signature'] ? this.roundsAndObservationsFormGroup.controls.cwpViolationSign.value.contractor : null,
        "coldWpId": this.cwpId,
        "workDetails": {
          "activitiesNeeded": this.workDetailsFormGroup.controls.cwpDetails.value['activitiesNeeded'].filter((ele)=>{return ele.checked == true}).map((ele1)=> {return ele1.name}).join(','),
          "columnNo": this.workDetailsFormGroup.controls.cwpDetails.value['columnNo'],
          "contractAgency": this.workDetailsFormGroup.controls.cwpDetails.value['contractAgency'],
          "id": this.workDetailsFormGroup.controls.cwpDetails.value['id'],
          "coldWorkPermitNo": this.workDetailsFormGroup.controls.cwpDetails.value['coldWorkPermitNo'],
          "dateOfIssue": this.workDetailsFormGroup.controls.cwpDetails.value['dateOfIssue'],
          "emailOfContractor": this.workDetailsFormGroup.controls.cwpDetails.value['emailOfContractor'],
          "fileName": this.workDetailsFormGroup.controls.contractorApprovalSign.value['fileName'],
          "fromDate": this.workDetailsFormGroup.controls.cwpDetails.value['fromDate'],
          "fromTime": this.workDetailsData['fromTime'],
          "isDraft": false,
          "issuedBy": this.workDetailsFormGroup.controls.cwpDetails.value['issuedBy'] ? this.workDetailsFormGroup.controls.cwpDetails.value['issuedBy']['id'] : null,
          "locationOfWork": this.workDetailsFormGroup.controls.cwpDetails.value['locationOfWork'],
          "mobileNoOfContractor": this.workDetailsFormGroup.controls.cwpDetails.value['mobileNoOfContractor'],
          "nameOfContractor": this.workDetailsFormGroup.controls.cwpDetails.value['nameOfContractor'],
          "otherActivitiesNeeded": this.workDetailsFormGroup.controls.cwpDetails.value['otherActivitiesNeeded'],
          "otherLocationOfWork": this.workDetailsFormGroup.controls.cwpDetails.value['otherLocationOfWork'],
          "otherSiteOfWork": this.workDetailsFormGroup.controls.cwpDetails.value['otherSiteOfWork'],
          "remark": this.workDetailsFormGroup.controls.cwpDetails.value['remark'],
          "savwiplexecutingDept": this.workDetailsFormGroup.controls.cwpDetails.value['savwiplexecutingDept'] ? this.workDetailsFormGroup.controls.cwpDetails.value['savwiplexecutingDept']['id'] : null,
          "savwiplexecutivingDeptPerson": this.workDetailsFormGroup.controls.cwpDetails.value['savwiplexecutivingDeptPerson'] ? this.workDetailsFormGroup.controls.cwpDetails.value['savwiplexecutivingDeptPerson']['id'] : null,
          "savwiploperationDept": this.workDetailsFormGroup.controls.cwpDetails.value['savwiploperationDept'] ? this.workDetailsFormGroup.controls.cwpDetails.value['savwiploperationDept']['id'] : null,
          "savwiploperationDeptPerson": this.workDetailsFormGroup.controls.cwpDetails.value['savwiploperationDeptPerson'] ? this.workDetailsFormGroup.controls.cwpDetails.value['savwiploperationDeptPerson']['id'] : null,
          "scopeOfWork": this.workDetailsFormGroup.controls.cwpDetails.value['scopeOfWork'],
          "signature": this.workDetailsFormGroup.controls.contractorApprovalSign.value['signature'],
          "siteOfWork": this.workDetailsFormGroup.controls.cwpDetails.value['siteOfWork'].filter((ele)=>{return ele.checked == true}).map((ele1)=> {return ele1.name}).join(','),
          "status": this.workDetailsFormGroup.controls.cwpDetails.value['status'],
          "toDate": this.workDetailsFormGroup.controls.cwpDetails.value['toDate'],
          "toTime": this.workDetailsData['toTime']
        }
      }
      this.showLoader();
      this.contractorService.addOrUpdateWorkPermitContractor(`/api/contractorColdWorkPermit/add-or-update-cold-workPermit-contractor`,request)
      .pipe(finalize(() => this.loadingRef?.dismiss()))
      .subscribe((resp: any) => {
        if(resp){
          this.isFormSubmited = true;
        }
      },error => { console.log("Error!!",error)});
    }else{
      this.contractorReportFormGroup.markAsDirty();
      this.contractorReportFormGroup.markAllAsTouched();
      this.errorAlert('Please fill all mandatory details');
    }
  }
  saveAsDraftAlert(){

  }
  async uploadSuccessMessage(message = 'Your signature has been uploaded successfully.') {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'saveAsDraftAlert Succuss2',
      header: '',
      message,
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });
    await alert.present();
  }
  async showLoader(msg = 'Please wait...') {
    if (this.loadingRef) {
      this.loadingRef?.dismiss()
    }
    this.loadingRef = await this.loadingController.create({
      duration: 6000,
      cssClass: 'please-wait',
      message: msg,
      translucent: true,
      backdropDismiss: true
    });
    await this.loadingRef.present();
  }
  async errorAlert(msg) {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'error-alert',
      header: '',
      message: `<p class="warning-text-header"><ion-icon name="information-circle-outline" color="warning"></ion-icon></p>
                ${msg}`,
      buttons:  [{
                    text: 'ok', role: 'Ok', cssClass: 'ok', handler: () => {alert.dismiss();}
                }]
    });
    await alert.present();
  }
  async hideLoaderIfExist() {
    if (this.loadingRef) {
      this.loadingRef?.dismiss();
    }
    const data = await this.loadingController?.getTop();
    if (data) {
      data?.dismiss();
    }
  }
}
